// User Module vuex

import axios from 'axios'

// State Module
const state = {
  selling: [],
  orders: null,
  money: 0
}

// Getters Module
const getters = {

  // Get All Selling
  getAllSelling: state => {
    let result = 0
    console.log(state)
    state.selling.forEach(item => {
      result += Number(item.count)
    })
    return result
  }

}

// Actions Module
const actions = {

  // Get Selling
  async getSelling ({ commit, rootState }, value) {
    let params = value ? '?' : ''
    if (value) {
      if (value.from) {
        const from = new Date(Number(value.from))
        params += 'dateFrom=' + `${from.getFullYear()}-${(from.getMonth() + 1).toString().padStart(2, '0')}-${from.getDate().toString().padStart(2, '0')}` + (value.to ? '&' : '')
      }
      if (value.to) {
        const to = new Date(Number(value.to))
        params += 'dateTo=' + `${to.getFullYear()}-${(to.getMonth() + 1).toString().padStart(2, '0')}-${to.getDate().toString().padStart(2, '0')}`
      }
    }
    await axios.get('/analytics/guide-selling' + params, {headers: {'Authorization': 'Bearer ' + rootState.token}}).then(({ data }) => {
      commit('setSelling', data.guides || [])
    }).catch(error => {
      console.log(error)
    })
  },

  // Get Selling
  async getOrders ({ commit, rootState }, value) {
    let params = value ? '?' : ''
    if (value) {
      if (value.from) {
        const from = new Date(Number(value.from))
        params += 'dateFrom=' + `${from.getFullYear()}-${(from.getMonth() + 1).toString().padStart(2, '0')}-${from.getDate().toString().padStart(2, '0')}` + (value.to ? '&' : '')
      }
      if (value.to) {
        const to = new Date(Number(value.to))
        params += 'dateTo=' + `${to.getFullYear()}-${(to.getMonth() + 1).toString().padStart(2, '0')}-${to.getDate().toString().padStart(2, '0')}`
      }
    }
    await axios.get('/analytics/orders' + params, {headers: {'Authorization': 'Bearer ' + rootState.token}}).then(({ data }) => {
      commit('setOrders', data)
    }).catch(error => {
      console.log(error)
    })
  },

  // Get Money
  async getMoney ({ commit, rootState }, value) {
    let params = value ? '?' : ''
    if (value) {
      if (value.from) {
        const from = new Date(Number(value.from))
        params += 'dateFrom=' + `${from.getFullYear()}-${(from.getMonth() + 1).toString().padStart(2, '0')}-${from.getDate().toString().padStart(2, '0')}` + (value.to ? '&' : '')
      }
      if (value.to) {
        const to = new Date(Number(value.to))
        params += 'dateTo=' + `${to.getFullYear()}-${(to.getMonth() + 1).toString().padStart(2, '0')}-${to.getDate().toString().padStart(2, '0')}`
      }
    }
    await axios.get('/analytics/money' + params, {headers: {'Authorization': 'Bearer ' + rootState.token}}).then(({ data }) => {
      commit('setMoney', data.amount)
      console.log(data)
    }).catch(error => {
      console.log(error)
    })
  },

  async getFilter ({ dispatch }, value) {
    if (value) {
      await dispatch('getSelling', {from: value.from, to: value.to})
      await dispatch('getOrders', {from: value.from, to: value.to})
      await dispatch('getMoney', {from: value.from, to: value.to})
    } else {
      await dispatch('getSelling')
      await dispatch('getOrders')
      await dispatch('getMoney')
    }
  }

}

// Mutations Module
const mutations = {

  // Set Selling Mutation
  setSelling (state, value) {
    state.selling = value
  },

  // Set Orders Mutation
  setOrders (state, value) {
    state.orders = value
  },

  // Set Money Mutation
  setMoney (state, value) {
    state.money = value
  }

}

// Export Module
export default {
  root: true,
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
